import { useTheme } from "@hooks";
import { IconProps } from "./types";

export const Deposit = ({ style, size = 34, fill: fillProp }: IconProps) => {
  const { theme } = useTheme();

  const fill = fillProp ?? theme.icon.default;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g clipPath="url(#clip0_deposit)">
        <circle cx="17" cy="17" r="17" fill="white" />
      </g>
      <path
        d="M20.2502 25.6666C17.8307 25.6666 15.7814 24.827 14.1022 23.1478C12.4231 21.4687 11.5835 19.4194 11.5835 16.9999C11.5835 14.5805 12.4231 12.5312 14.1022 10.852C15.7814 9.17284 17.8307 8.33325 20.2502 8.33325C22.6696 8.33325 24.7189 9.17284 26.3981 10.852C28.0772 12.5312 28.9168 14.5805 28.9168 16.9999C28.9168 19.4194 28.0772 21.4687 26.3981 23.1478C24.7189 24.827 22.6696 25.6666 20.2502 25.6666ZM11.9627 25.3416C9.92238 25.0888 8.26579 24.1544 6.99287 22.5385C5.71995 20.9225 5.0835 19.0763 5.0835 16.9999C5.0835 14.9235 5.71995 13.0773 6.99287 11.4614C8.26579 9.8454 9.92238 8.91103 11.9627 8.65825V10.2291C10.3738 10.518 9.10086 11.3079 8.14391 12.5989C7.18697 13.8898 6.7085 15.3569 6.7085 16.9999C6.7085 18.643 7.18697 20.11 8.14391 21.401C9.10086 22.6919 10.3738 23.4819 11.9627 23.7708V25.3416ZM20.2502 24.0416C22.1821 24.0416 23.8387 23.351 25.22 21.9697C26.6012 20.5885 27.2918 18.9319 27.2918 16.9999C27.2918 15.068 26.6012 13.4114 25.22 12.0301C23.8387 10.6489 22.1821 9.95825 20.2502 9.95825C18.3182 9.95825 16.6616 10.6489 15.2804 12.0301C13.8991 13.4114 13.2085 15.068 13.2085 16.9999C13.2085 18.9319 13.8991 20.5885 15.2804 21.9697C16.6616 23.351 18.3182 24.0416 20.2502 24.0416Z"
        fill={fill}
      />
      <path
        d="M19.8574 21.5V17.6429H16V16.3571H19.8574L19.8569 12.5H21.1426L21.1431 16.3571H25V17.6429H21.1431V21.5H19.8574Z"
        fill={fill}
      />
      <defs>
        <clipPath id="clip0_deposit">
          <rect width={size} height={size} rx="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
